import OrderSchoolItem from './OrderSchoolItem.component';

export default OrderSchoolItem;
